import api from "./api";

export const getPaineis = async (params) => {
    const response = api.get(`/operational-panel${params ? `?${params}` : ""}`);
    return response;
}
export const fnGetPainel = async (params) => {
    const response = api.get(`/operational-panel?ids=${params}`);
    return response;
}
export const fnGetPainelBoard = async (params) => {
    const response = api.get(`/operational-panel/${params}`);
    return response;
}
export const createPainel = async (data) => {
    const response = api.post(`/operational-panel`, data);
    return response;
}
export const delPainel = async (body) => {
    const response = api.delete(`/operational-panel/${body.id}`, { data: { password: body.password } });
    return response;
}
export const EditPainel = async (oData) => {
    const response = api.put(`/operational-panel/${oData.id}`, oData);
    return response;
}   